import { useSelector, useDispatch } from 'react-redux';
import pickBy from 'lodash/pickBy';

import { selectAssignmentHashKeys, resetAssignmentHashKeys } from '@containers/upf-assign/upf-assign-actions';

import { buildAssignmentHashKeys, getProgressPercentage } from '@components/status-cell/helpers';

import { checkIsInBetween } from '../helpers';

const useQuickSelector = ({ closeContextMenu }) => {
  /**
   * Store
   */
  const assignments = useSelector(state => state.entitiesReducer.assignments);
  const sortedStudentIds = useSelector(state => state.UPFAssignReducer.sortedStudentIds);
  const selectedLearningJourneyIds = useSelector(state => state.UPFAssignReducer.selectedLearningJourneyIds);

  const dispatch = useDispatch();

  /**
   * Local variables
   */
  const assignmentHashKeys = buildAssignmentHashKeys({
    studentIds: sortedStudentIds,
    learningJourneyIds: selectedLearningJourneyIds
  });

  /**
   * Functions
   */
  const selectAllAssignments = () => {
    dispatch(resetAssignmentHashKeys());
    dispatch(selectAssignmentHashKeys(assignmentHashKeys));
    closeContextMenu();
  };

  const selectCurrentAssigned = () => {
    const updatedHashKeys = pickBy(assignmentHashKeys, (_, key) => {
      const assignment = assignments[key] || {};

      return !!assignment.currentAssignmentId;
    });

    dispatch(resetAssignmentHashKeys());
    dispatch(selectAssignmentHashKeys(updatedHashKeys));
    closeContextMenu();
  };

  const selectProgressPercentageBetween = (start, end) => {
    const updatedHashKeys = pickBy(assignmentHashKeys, (_, key) => {
      const assignment = assignments[key] || {};
      const percentage = getProgressPercentage(assignment);

      return checkIsInBetween(percentage, start, end);
    });

    dispatch(resetAssignmentHashKeys());
    dispatch(selectAssignmentHashKeys(updatedHashKeys));
    closeContextMenu();
  };

  const selectAccuracyBetween = (start, end) => {
    const updatedHashKeys = pickBy(assignmentHashKeys, (_, key) => {
      const { resultAccuracy } = assignments[key] || {};

      if (!resultAccuracy) return false;

      return checkIsInBetween(resultAccuracy, start, end);
    });

    dispatch(resetAssignmentHashKeys());
    dispatch(selectAssignmentHashKeys(updatedHashKeys));
    closeContextMenu();
  };

  const cleanAssignmentHashKeys = () => {
    dispatch(resetAssignmentHashKeys());
    closeContextMenu();
  };

  return {
    cleanAssignmentHashKeys,
    selectAllAssignments,
    selectCurrentAssigned,
    selectProgressPercentageBetween,
    selectAccuracyBetween
  };
};

export default useQuickSelector;
